import { FormInstance } from "antd";
import { useCallback, useState } from "react";
import { updateContract } from "../../../acions/accounts/contracts";
import { useAppDispatch } from "../../../store";
import { Dayjs } from "dayjs";
import { useTransformAmounts } from "../components/View/Admin/Details/hooks/useTransformAmounts";
import { updateMailingKey } from "../../../acions/actionsCreators/mailingKeyActions";

export const useUpdateAccount = (
  form: FormInstance,
  contractId: string,
  setIsFormDisabled: (value: boolean) => void,
) => {
  const dispatch = useAppDispatch();

  const [lcSectionKey, setLcSectionKey] = useState<boolean>(false);

  const formatDate = useCallback((data: any, prop: string, value: Dayjs) => {
    data[prop] = value ? value.startOf("D").format() : undefined;
  }, []);

  const { transform } = useTransformAmounts(true);

  const getFormattedRequest: any = useCallback(
    (request: any) => {
      let data: any = { ...request };

      const {
        nextDueDate,
        interestCalculationDate,
        beginningDate,
        balanceDueDate,
      } = request;

      formatDate(data, "interestCalculationDate", interestCalculationDate);
      formatDate(data, "nextDueDate", nextDueDate);

      formatDate(data, "balanceDueDate", balanceDueDate);
      formatDate(data, "beginningDate", beginningDate);

      delete data.lateChargeAssessedDate;

      transform(data);

      if (!data.principalAndInterestAmount) {
        data.principalAndInterestAmount = 0;
      }

      return data;
    },
    [formatDate, transform],
  );

  const update = useCallback(
    async (onSuccess?: () => void) => {
      try {
        const res = await form.validateFields();
        const request: any = getFormattedRequest(res);

        setIsFormDisabled(true);
        await Promise.resolve(dispatch(updateContract(contractId, request)));
        setIsFormDisabled(false);
        onSuccess && onSuccess();

        setLcSectionKey(!lcSectionKey);

        dispatch(updateMailingKey());

        return true;
      } catch {
        setIsFormDisabled(false);

        return false;
      }
    },
    [
      form,
      getFormattedRequest,
      setIsFormDisabled,
      dispatch,
      contractId,
      lcSectionKey,
    ],
  );

  return {
    update,
    lcSectionKey,
  };
};
